import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '~/reducers';

const useSetSentryUser = () => {
  const user = useSelector((state: AppState) => state.authentication);
  useEffect(() => {
    if (user.isUserInfoFetched) {
      Sentry.setUser({
        id: user.userId,
      });
    }
  }, [user.isUserInfoFetched, user.userId]);
};
export { useSetSentryUser };
